import axios from 'axios';

import api from 'api/instance';

import { CustomerPortal } from 'types/site';

const URL = `${process.env.REACT_APP_API_URL}`;

export const fetchPortal = async (portalName: string) => {
  const { data } = await api.get(
    `${URL}/customer-portal/portal-details/${portalName}`,
  );

  return data?.item as CustomerPortal;
};

export const createRequest = async (payload: any, id: string) => {
  const { data } = await api.post(
    `${URL}/customer-portal/create-request-order/${id}`,
    payload,
  );

  return data;
};

export const uploadPortalLogo = async (file: File, portalName: string) => {
  const formData = new FormData();
  formData.append('image', file);

  // Deliberately not the shared `api` instance: its auth-refresh interceptor
  // redirects to /login on any 401, which would eject a customer from this
  // public order form. The endpoint is unauthenticated, so no token is needed.
  const { data } = await axios.post(
    `${URL}/customer-portal/upload-logo/${portalName}`,
    formData,
  );

  return data?.item?.logo as string;
};
